import env from '@tencent/vft-common/env';
import { request } from '@tencent/vft-common/request';
import { getUrlParam } from '@tencent/vft-common/util';

import { CAPTCHA_CODE } from 'src/config';
import { getQimeiSign, loadQimeiLib } from 'src/util/index';

const host = location.host === 'film.qq.com' ? 'hwvip.video.qq.com' : 'hwvip.wetv.vip';

const pbaccessHost = +getUrlParam('debugger') === 1 ? 'pbdebugaccess.wetv.vip' : 'pbaccess.wetv.vip';

const getPlatform = function () {
  const ua = navigator.userAgent;
  const isIos = ua.indexOf('iPhone') !== -1;
  const isAndroid = ua.indexOf('Android') !== -1;
  const isIPad = ua.indexOf('iPad') !== -1;

  if (env.isApp) {
    if (isIos) return 5;
    if (isAndroid) return 3;
    if (isIPad) return 4;
    return 1;
  }
  return 2;
};

/**
* time33
* @param {string} key 从cookie中获取到的vuesssion
*/
const getGtk = (key) => {
  let hash = 5381;
  if (key) {
    for (let i = 0; i < key.length; i++) {
      hash += (hash << 5) + key.charCodeAt(i);
    }
  }
  return hash & 0x7fffffff;
};

export const getWetvGtk = () => {
  const fullCookie = document.cookie;
  const cookieName = 'vusession';
  const r = new RegExp(`(?:^|;+|\\s+)${cookieName}=([^;]*)`);
  const m = fullCookie.match(r);
  const vusession = m ? m[1] : '';
  return vusession && getGtk(vusession);
};

export function isFirst() {
  return new Promise((resolve) => {
    const platform = getPlatform();
    $.ajax({
      url: `//${host}/fcgi-bin/hw_comm_cgi?name=cdkey_user_info&cmd=63032&otype=json`,
      dataType: 'jsonp',
      data: {
        platform,
      },
      success: (json) => {
        if (json && +json.ret === 0 && +json.fist_exchange === 0) {
          resolve(false);
          return;
        }
        resolve(true);
      },
      error: (xhr, errorType, error) => {
        console.error(error);
        resolve(true);
      },
    });
  });
}

const userType = {
  phone: 3,
};
const bidId = {
  wetv: 1,
};

export const getUserPhone = () => new Promise((resolve, reject) => {
  $.ajax({
    url: `//${pbaccessHost}/trpc_identity_info.IdentityInfo/GetIdentity`,
    xhrFields: {
      withCredentials: true,
    },
    data: {
      video_appid: 1200004,
      vplatform: getPlatform(),
      g_vstk: getWetvGtk(),
      biz_id: bidId.wetv,
    },
    success: (res) => {
      const accountList = (res && res.data && res.data.account) || [];
      const phoneAccount = accountList.find(account => account.user_type === userType.phone);
      const { user_id: phone = '', area_id: areacode = '' } = phoneAccount || {};
      resolve((phone && { areacode, phone }) || null);
    },
    error: (xhr, errorType, error) => reject(error),
  });
});

export function redeem(appid, cdkey, captchaCode, captchaTicket, phone, phoneCode, areaCode, scene = 'cdkey', aid = null) {
  const platform = getPlatform();
  // testAlert('redeem arg', arguments)
  return new Promise((resolve) => {
    $.ajax({
      url: `//${host}/fcgi-bin/hw_comm_cgi?name=cdkey_exchange&cmd=62570&otype=json`,
      dataType: 'jsonp',
      data: {
        appid,
        cdkey,
        captcha_code: captchaCode,
        captcha_ticket: captchaTicket,
        phone,
        phone_code: phoneCode,
        area_code: areaCode,
        scene,
        aid,
        platform,
      },
      success: (json) => {
        resolve(json);
      },
      error: (xhr, errorType, error) => {
        console.error(error);
        resolve(false);
      },
    });
  });
}

export async function sendOtpCode(areacode, phone, scene = 'bind_phone') {
  const [res] = await Promise.all([
    new Promise((resolve, reject) => {
      const captcha = new window.TencentCaptcha(CAPTCHA_CODE, (res) => {
        if (res.errorCode) {
          return reject(new Error(res.errorMessage + res.errorCode));
        }
        resolve(res);
      });
      captcha.show();
    }),
    loadQimeiLib(),
  ]);
  const url = `https://${pbaccessHost}/trpc.video_app_international.trpc_otp.TrpcOtp/SendOTPCode?video_appid=1200004`;
  const qimeiSign = await getQimeiSign(url);
  const options = {
    xhrFields: { withCredentials: true },
    dataType: 'json',
    type: 'POST',
    headers: {
      'Content-Type': 'application/json',
      video_captcha_ticket: res.ticket,
      video_captcha_randstr: res.randstr,
      h38_sign: qimeiSign,
    },
  };
  const data = {
    scene,  // 业务场景 (接口负责人分配)
    account: {
      user_type: 3,  // 3=手机 (user_id填手机号, area_id填国际电话区号) 4=邮箱 (user_id填邮箱)
      user_id: phone,
      area_id: areacode,
    },
  };
  return request(url, JSON.stringify(data), options);
}
